import { request } from 'core/constants'
import { requestState } from 'utils/UtilityStore/actions'

export const fetch =
  (filter, order = null, orderDirection = null) =>
  (dispatch) => {
    dispatch(requestState(true, 'guarantors'))
    const orderBy = order && orderDirection ? order + ',' + orderDirection : ''

    request
      .get(
        `{company}/guarantor?page=${filter?.page || 1}&search=${
          filter?.search || ''
        }&orderBy=${orderBy}`,
      )
      .then((response) => {
        dispatch(requestState(false, 'guarantors'))
        dispatch({
          type: 'FETCH_GUARANTORS',
          payload: response.data,
          listInfo: response.resultsInfo,
        })
      })
      .catch((error) => {})
  }
